import { Market } from "../../contracts";
import { mapSelectionsOdds } from "../mapSelectionsOdds";

export const mapMarketsSelectionsOdds = (markets: Market[], oddStyle: number) => {
    return markets.map(
        (market) => {
            market.selections = mapSelectionsOdds(market.selections, oddStyle)
            return market;
        }
    )
}